export const UserStatusEnum = Object.freeze({0:"INACTIVE", 1:"ACTIVE"})
